"use client";

import { MediaWorkspace } from "../_components/MediaWorkspace";
import { trimAudioOperation } from "../_operations/trimAudio";

export function TrimAudioContent() {
  return <MediaWorkspace operation={trimAudioOperation} />;
}
